var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"farm-block",on:{"click":_vm.selectFarm}},[_c('div',[_c('div',{staticClass:"farm-company",attrs:{"title":_vm.item.company_name}},[_vm._v(_vm._s(_vm.formattedName))]),_c('div',{staticClass:"farm-name"},[_vm._v(_vm._s(_vm.item.name))])]),_c('v-icon',{attrs:{"icon":"chevron-right","color":"#1DA643","font-size":"1.2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }